import produce from 'immer';
import { ShipmentStatus } from '../@posturinn/client-react';
import {
	TRACK_SHIPMENT_FAILED,
	TRACK_SHIPMENT_FULFILLED,
	TRACK_SHIPMENT_PENDING,
} from '../constants/actions/trackShipmentActions';
import ITrackShipmentReducer from '../interfaces/trackShipment/trackShipmentReducer';

const initialValues: ITrackShipmentReducer = {
	shipmentInfo: null,
	trackShipmentError: false,
	trackShipmentLoading: false,
	allPossibleTrackAndTrace: [],
};

export const parseStatusAsStep = (status, maxStep) => {
	let newStatusStep = -1;

	switch (status) {
		case ShipmentStatus.AvailableForPickup:
			newStatusStep = maxStep - 1;
			break;
		case ShipmentStatus.AvailableForPickupAtParcelPoint:
			newStatusStep = maxStep - 1;
			break;
		case ShipmentStatus.AvailableForPickupAtPostBox:
			newStatusStep = maxStep - 1;
			break;
		case ShipmentStatus.AvailableForPickupAtPostOffice:
			newStatusStep = maxStep - 1;
			break;
		case ShipmentStatus.UnsuccessfulHomeDeliveryAttempt:
			newStatusStep = maxStep - 1;
			break;
		// case ShipmentStatus.Cancelled:
		// 	break;
		case ShipmentStatus.CourierPickup:
			newStatusStep = 1;
			break;
		case ShipmentStatus.Delivered:
			newStatusStep = maxStep;
			break;
		case ShipmentStatus.DepartedFromSender:
			newStatusStep = 1;
			break;
		// case ShipmentStatus.Error:
		// 	break;
		case ShipmentStatus.InternationalShipmentArrivedInIceland:
			newStatusStep = 0;
			break;
		case ShipmentStatus.InternationalShipmentExpectedFromAbroad:
			newStatusStep = -1;
			break;
		case ShipmentStatus.InTransit:
			newStatusStep = maxStep - 2;
			break;
		case ShipmentStatus.InTransitAbroad:
			newStatusStep = maxStep - 2;
			break;
		case ShipmentStatus.InvoiceReceived:
			newStatusStep = 2;
			break;
		case ShipmentStatus.OnHold:
			newStatusStep = 2;
			break;
		case ShipmentStatus.OutForHomeDelivery:
			newStatusStep = maxStep - 1;
			break;
		case ShipmentStatus.PreTransit:
			newStatusStep = 0;
			break;
		case ShipmentStatus.ReturnedToSender:
			newStatusStep = maxStep;
			break;
		// case ShipmentStatus.Unknown:
		// 	break;
		default:
			break;
	}

	return newStatusStep;
};

const trackShipmentReducer = produce((draft: ITrackShipmentReducer, action) => {
	switch (action.type) {
		case TRACK_SHIPMENT_PENDING: {
			draft.trackShipmentLoading = true;
			draft.trackShipmentError = false;
			draft.shipmentInfo = null;
			break;
		}
		case TRACK_SHIPMENT_FULFILLED: {
			draft.trackShipmentLoading = false;
			draft.shipmentInfo = action.payload.results;
			draft.trackShipmentError = false;
			if (!draft.shipmentInfo.error) {
				let nrOfSteps: number = 6;
				if (draft.shipmentInfo.isDomestic) nrOfSteps = 5;

				const maxStep = nrOfSteps - 1;
				const newStatusStep: number = parseStatusAsStep(draft.shipmentInfo.shipmentStatus, maxStep);

				draft.shipmentInfo.adjustedStatus = {
					numberOfSteps: nrOfSteps,
					adjustedStatusStep: newStatusStep,
				};
			}
			draft.allPossibleTrackAndTrace = action.payload.allTrackAndTraces;
			break;
		}
		case TRACK_SHIPMENT_FAILED: {
			draft.trackShipmentLoading = false;
			draft.trackShipmentError = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default trackShipmentReducer;
